(() => {
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-jeetee-gallery-open]');
    if (opener) {
      const gallery = opener.closest('[data-jeetee-gallery]');
      const dialog = gallery?.querySelector('[data-jeetee-gallery-dialog]');
      const image = dialog?.querySelector('img');
      if (!dialog || !image) return;
      image.src = opener.dataset.fullImage;
      dialog.showModal();
      return;
    }

    const closer = event.target.closest('[data-jeetee-gallery-close]');
    if (closer) closer.closest('dialog')?.close();

    if (event.target.matches('[data-jeetee-gallery-dialog]')) event.target.close();
  });
})();
